import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {
  WoJobSLAHistoryDetail, WoSLADetails, WoJobSLAHistoryEntityList
} from '../../work-order/work-order-models';

import { FPMessage, Severities, PageKey, RoleAccess } from '../../shared/shared.model';
import { WoService } from '../../work-order/work-order.service';
import { TranslateService } from '@ngx-translate/core';
import { SharedService } from '../../shared/shared.service';
import { PopupInit } from '../../shared/init-popup';
import { DatePipe } from '@angular/common';
import { Message, ConfirmationService } from 'primeng/primeng';
import { BaseComponent } from '../../shared/base.component';
import { CapitalizeFirstPipe } from '../../shared/pipes/custom-pipes.pipe';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { LoaderService } from '../../shared/loader.service';


@Component({
  // moduleId: module.id,
  selector: 'sla-detail-popup',
  templateUrl: 'sla-detail-popup.component.html'
})
export class SlaDetailPopupComponent extends BaseComponent implements OnInit {
  public searchfield = new FormControl();

  wojobSLAHistoryDetail: WoJobSLAHistoryDetail[];
  woSLAdtails: WoSLADetails;
  woSLApageHistory: WoJobSLAHistoryEntityList;
  @Input() WojobId: number;
  @Input() SLATypeId: number;
  @Output() done = new EventEmitter();
  cols: any[];
  stacked: boolean;
  public rows: number;
  public page: number;
  public order: string;
  public sortby: string;
  public rowsperOptions: any;
  public getRows: number;
  TotalCount: number;
  slaStartsAt: string;
  slaEndsAt: string;
  constructor(protected translateService: TranslateService, private loaderservice: LoaderService, protected _woService: WoService,
    private formBuilder: FormBuilder, private route: ActivatedRoute,
    private datePipe: DatePipe, protected sharedService: SharedService) {
    super(sharedService, translateService)
    this.rowsperOptions = this.sharedService.getRowsPerOptions();
    this.getRows = this.sharedService.getRows();
  }
  ngOnInit() {
    //Set columns for grid
    this.translate.get(['JOBNO', 'JOBCREATEDON', 'CUSTOMERPREFDATETIME', 'PRIORITYNAME', 'slaStartsAt', 'SLAEndTime','Durationstr','IsSLAMet']).subscribe(s => {
      this.cols = [
          {field: 'WoJobId', header: s.JOBNO },
          {field: 'CreatedDate', header: s.JOBCREATEDON },
          {field: 'ApptPrefDate', header: s.CUSTOMERPREFDATETIME },
          {field: 'PriorityName', header: s.PRIORITYNAME },
          {field: 'SLAStartTime', header: s.slaStartsAt },
          {field: 'SLAEndTime', header: s.SLAEndTime },
          {field: 'Durationstr', header: s.Durationstr },
          {field: 'IsSLAMet', header: s.IsSLAMet }
      ];
  });
    this.woSLAdtails = new WoSLADetails();
    this.woSLApageHistory = new WoJobSLAHistoryEntityList();
    this.wojobSLAHistoryDetail = [];
    // this.wojobSLAHistoryDetail=[];
    this.rows = this.getRows;
    this.page = 0;
    this.order = "PriorityName";
    this.sortby = "Desc";
    this.woSLAdtails.WoJobId = this.WojobId;
    this.woSLAdtails.SortBy = this.sortby;
    this.woSLAdtails.OrderBy = this.order;
    this.woSLAdtails.startRecord = this.page;
    this.woSLAdtails.EndRecord = this.rows;
    this.woSLAdtails.CompanyId = this.globalInfo().CompanyId;
    this.woSLAdtails.SLATypeId = this.SLATypeId;

    if (this.WojobId) {
      this.getSlaDetails();
    }
    this.slaStartsAt = this.SLATypeId == 1 ? this.translate.instant("RESOLUTION") : this.translate.instant("RESPONSE");
    this.slaStartsAt = this.slaStartsAt + ' ' + this.translate.instant("SLASTARTTIME");
    this.slaEndsAt = this.SLATypeId == 1 ? this.translate.instant("RESOLUTION") : this.translate.instant("RESPONSE");
    this.slaEndsAt = this.slaEndsAt + ' ' + this.translate.instant("SLAENDTIME");
  }
  getSlaDetails() {

    this._woService.getWoSLApageHistory(this.woSLAdtails).subscribe(resp => {
      if (resp != null) {        
        //    this.woSLApageHistory = new WoJobSLAHistoryEntityList;
        this.woSLApageHistory = resp;
        this.woSLApageHistory.WoJobSLAHistoryDetail.map(x => {
          x.CreatedDate = x.CreatedDate ? this.datePipe.transform(x.CreatedDate, 'short') : null;
          x.ApptPrefDate = x.ApptPrefDate ? this.datePipe.transform(x.ApptPrefDate, 'short') : null;
          x.SLAStartTime = x.SLAStartTime ? this.datePipe.transform(x.SLAStartTime, 'short') : null;
          x.SLAEndTime = x.SLAEndTime ? this.datePipe.transform(x.SLAEndTime, 'short') : null;
          if (x.SLADurationTypeId != 1 && x.SLADurationTypeId != 0 && x.SLADurationTypeId != null) {
            x.Durationstr = x.SLADurationType;
          }
        }
        );
        this.TotalCount = resp.TotalRecord;
      }
    });
  }
  toggle() {
    this.stacked = !this.stacked;
  }
  refreshGrid() {

    this.loaderservice.show();
    this.rows = this.getRows;
    this.page = 0;
    this.order = "PriorityName";
    this.sortby = "Desc";
    this.woSLAdtails.WoJobId = this.WojobId;
    this.woSLAdtails.SortBy = this.sortby;
    this.woSLAdtails.OrderBy = this.order;
    this.woSLAdtails.startRecord = this.page;
    this.woSLAdtails.EndRecord = this.rows;
    this.woSLAdtails.CompanyId = this.globalInfo().CompanyId;
    this.woSLAdtails.SLATypeId = this.SLATypeId;

    if (this.WojobId) {
      this.getSlaDetails();
    }
    this.loaderservice.hide();
  }
  paginate(event) {

    var status = -1;
    this.woSLAdtails.SortBy = this.sortby;
    this.woSLAdtails.OrderBy = this.order;
    this.woSLAdtails.startRecord = event.page;
    this.page = event.page;
    this.woSLAdtails.EndRecord = event.rows;
    this.woSLAdtails.WoJobId = this.WojobId;
    this.woSLAdtails.CompanyId = this.globalInfo().CompanyId;
    this.woSLAdtails.SLATypeId = this.SLATypeId;

    this.rows = event.rows;
    this._woService.getWoSLApageHistory(this.woSLAdtails).subscribe(resp => {
      if (resp != null) {

        this.woSLApageHistory = resp;
        this.woSLApageHistory.WoJobSLAHistoryDetail.map(x => {
          x.CreatedDate = x.CreatedDate ? this.datePipe.transform(x.CreatedDate, 'short') : null;
          x.ApptPrefDate = x.ApptPrefDate ? this.datePipe.transform(x.ApptPrefDate, 'short') : null;
          if (x.SLADurationTypeId != 1 && x.SLADurationTypeId != 0 && x.SLADurationTypeId != null) {
            x.Durationstr = x.SLADurationType;
          }
        }
        );
        this.TotalCount = resp.TotalRecord;
      }
    });
  }
  sort(event) {

    var status = -1;
    if (event.order == 1)
      this.sortby = "Asc";
    else
      this.sortby = "Desc";
    this.woSLAdtails.SortBy = this.sortby;
    this.woSLAdtails.OrderBy = event.field;
    this.order = event.field;
    this.woSLAdtails.WoJobId = this.WojobId;
    this.woSLAdtails.startRecord = this.page;
    this.woSLAdtails.EndRecord = this.rows;
    this.woSLAdtails.CompanyId = this.globalInfo().CompanyId;
    this.woSLAdtails.SLATypeId = this.SLATypeId;

    this._woService.getWoSLApageHistory(this.woSLAdtails).subscribe(resp => {
      if (resp != null) {
        //   this.woSLApageHistory = new WoJobSLAHistoryEntityList;
        this.woSLApageHistory = resp;
        this.woSLApageHistory.WoJobSLAHistoryDetail.map(x => {
          x.CreatedDate = x.CreatedDate ? this.datePipe.transform(x.CreatedDate, 'short') : null;
          x.ApptPrefDate = x.ApptPrefDate ? this.datePipe.transform(x.ApptPrefDate, 'short') : null;
          if (x.SLADurationTypeId != 1 && x.SLADurationTypeId != 0 && x.SLADurationTypeId != null) {
            x.Durationstr = x.SLADurationType;
          }
        }
        );
        this.TotalCount = resp.TotalRecord;
      }
    });
  }
  closePopup() {
    this.done.emit(0);
  }
  Ispopupopen: boolean = true;
  rightpanel() {
      this.Ispopupopen = !this.Ispopupopen;
  }

}